const _temp0 = require("./assets/doorstop.png");
const _temp1 = require("./assets/koodi.png");
const _temp2 = require("./assets/tommy.png");
module.exports = {
  "doorstop": _temp0,
  "koodi": _temp1,
  "tommy": _temp2
}